import angular from 'angular';

import headerBar from './header/bar';
import headerMenu from './header/menu';
import productItem from './product/item';
import productSimple from './product/simple';
import productSearchSimple from './product/search-simple';
import footerBar from './footer';

export default angular.module('directives', [])
    .directive(...headerMenu)
    .directive(...headerBar)
    .directive(...productItem)
    .directive(...productSimple)
    .directive(...productSearchSimple)
    .directive(...footerBar)
    .name;



// WEBPACK FOOTER //
// ./src/app/directives/directives.js